export const getCategoryListFromQuery = (categoryList) => {
  return categoryList && categoryList.data && categoryList.data.map(item => ({value: item.id, label: item.title}))
}



// WEBPACK FOOTER //
// ./src/helpers/project.helper.js